import {Action} from '@ngrx/store';
import {Shift} from '@app/core/models/shift.model';
import {User} from '@app/core/models/user.model';
import {DayNote} from '@app/core/models/day-note.model';
import {Pagination} from '@app/core/models/pagination.model';
import {Department} from '@app/core/models/department.model';
import {Tenant} from '@app/core/models/tenant.model';

export enum EPunchClockActions {
	GetPunchClockUsers = '[PunchClock] Get Punch Clock Users',
	GetPunchClockUsersSuccess = '[PunchClock] Get Punch Clock Users Success',
	PunchInUser = '[PunchClock] Punch In User',
	PunchInUserSuccess = '[PunchClock] Punch In User Success',
	PunchOutUser = '[PunchClock] Punch Out User',
	PunchOutUserSuccess = '[PunchClock] Punch Out User Success',
	GetPunchDayNotes = '[PunchClock] Get Punch Day Notes',
	GetPunchDayNotesSuccess = '[PunchClock] Get Punch Day Notes Success',
	OpenPunchModal = '[PunchClock] Open Punch Modal',

	SetPunchPinCode = '[PunchClock] Set Punch Pin Code',
	SetPunchPinCodeSuccess = '[PunchClock] Set Punch Pin Code Success',

	GetPunchDepartment = '[PunchClock] Get Punch Department',
	GetPunchDepartmentSuccess = '[PunchClock] Get Punch Department Success',
	GetPunchTenant = '[PunchClock] Get Punch Tenant',
	GetPunchTenantSuccess = '[PunchClock] Get Punch Tenant Success',
	SetDepartmentInLogin = '[PunchClock] Set Department In Login',

	ClearPunchDayNotes = '[PunchClock] Clear Punch Day Notes',
}

export class GetPunchClockUsers implements Action {
	public readonly type = EPunchClockActions.GetPunchClockUsers;

	constructor(public page_size: number, public page: number, public inSchedule: boolean = false, public searchTerm: string = undefined) {
	}
}

export class GetPunchClockUsersSuccess implements Action {
	public readonly type = EPunchClockActions.GetPunchClockUsersSuccess;

	constructor(public users: User[], public pagination: Pagination) {
	}
}

export class PunchInUser implements Action {
	public readonly type = EPunchClockActions.PunchInUser;

	constructor(public userId: number, public groupId: number, public pinCode?: number) {
	}
}

export class PunchInUserSuccess implements Action {
	public readonly type = EPunchClockActions.PunchInUserSuccess;

	constructor(public user: User) {
	}
}

export class PunchOutUser implements Action {
	public readonly type = EPunchClockActions.PunchOutUser;

	constructor(public userId: number, public punchNote: string, public pinCode?: number) {
	}
}

export class PunchOutUserSuccess implements Action {
	public readonly type = EPunchClockActions.PunchOutUserSuccess;

	constructor(public user: User) {
	}
}

export class GetPunchDayNotes implements Action {
	public readonly type = EPunchClockActions.GetPunchDayNotes;

	constructor(public page_size: number, public page: number, public date: string) {
	}
}

export class GetPunchDayNotesSuccess implements Action {
	public readonly type = EPunchClockActions.GetPunchDayNotesSuccess;

	constructor(public dayNotes: DayNote[], public pagination: Pagination) {
	}
}

export class OpenPunchModal implements Action {
	public readonly type = EPunchClockActions.OpenPunchModal;

	constructor(public data: { punchedIn: boolean, shift: Shift, user: User }) {
	}
}

export class SetDepartmentInLogin implements Action {
	public readonly type = EPunchClockActions.SetDepartmentInLogin;

	constructor(public department: Department) {
	}
}

export class GetPunchDepartment implements Action {
	public readonly type = EPunchClockActions.GetPunchDepartment;

	constructor(public id: number) {
	}
}

export class GetPunchDepartmentSuccess implements Action {
	public readonly type = EPunchClockActions.GetPunchDepartmentSuccess;

	constructor(public department: Department) {
	}
}

export class GetPunchTenant implements Action {
	public readonly type = EPunchClockActions.GetPunchTenant;

	constructor(public id: number) {
	}
}

export class GetPunchTenantSuccess implements Action {
	public readonly type = EPunchClockActions.GetPunchTenantSuccess;

	constructor(public tenant: Tenant) {
	}
}

export class SetPunchPinCode implements Action {
	public readonly type = EPunchClockActions.SetPunchPinCode;

	constructor(public id: number, public data: { pin_code: string }) {
	}
}

export class SetPunchPinCodeSuccess implements Action {
	public readonly type = EPunchClockActions.SetPunchPinCodeSuccess;

	constructor(public user: User) {
	}
}

export class ClearPunchDayNotes implements Action {
	public readonly type = EPunchClockActions.ClearPunchDayNotes;

	constructor() {
	}
}

export type PunchClockActions =
	GetPunchClockUsers |
	GetPunchClockUsersSuccess |
	PunchInUser |
	PunchInUserSuccess |
	PunchOutUser |
	PunchOutUserSuccess |
	OpenPunchModal |
	GetPunchDayNotes |
	GetPunchDayNotesSuccess |
	SetDepartmentInLogin |
	GetPunchDepartment |
	GetPunchDepartmentSuccess |
	GetPunchTenant |
	GetPunchTenantSuccess |
	SetPunchPinCode |
	SetPunchPinCodeSuccess |
	ClearPunchDayNotes
	;
